export default __webpack_public_path__ + "static/media/flag-transnistria.e9b3d179.svg";